module.exports = __webpack_public_path__ + "img/gsb28.f34a572c.png";